import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActionLog, AddActionLog } from "../models/actionLog";
import { EnvironmentService } from "./environment.service";

@Injectable({
  providedIn: "root",
})
export class ActionLogService {
  constructor(private http: HttpClient, private env: EnvironmentService) {}

  getActionLogs(
    entityType: string,
    entityPath: string,
    entityName: string,
    action: string,
    actionLevel: number,
    initiator: string,
    entries: number,
    toDownload: boolean = false
  ) {
    if (entityType.charAt(entityType.length - 1).toLowerCase() === "s") {
      entityType = entityType.slice(0, -1); // Remove the last character
    }
    let baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}ActionLogs/EntityType/${entityType}/EntityPath/${entityPath}/EntityName/${entityName}/GetActionLogs`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("ActionToFilter", action)
      .set("ActionLevelToFilter", actionLevel.toString())
      .set("InitiatorToFilter", initiator)
      .set("Entries", entries ? entries.toString() : "0")
      .set("ToDownload", toDownload?.toString());
    return this.http.get(baseUrl, { headers: headers });
  }

  deleteActionLogs(depName: string, actionLogIds: Array<any>) {
    let baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}ActionLogs/Deployment/${depName}/DeleteActionLogs`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache");

    return this.http.post(baseUrl, actionLogIds, { headers: headers });
  }

  addActionLog(
    depName: string,
    action: string,
    actionOn: string,
    entityName: string,
    entityType: string,
    description: string = "",
    actionLevel: number = 2,
    status: string = "",
  ) {
    let actionLogObj: AddActionLog = {
      action: action,
      actionOn: actionOn,
      entityName: entityName,
      description: description,
      actionLevel: actionLevel,
    };
    let baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}ActionLogs/Deployment/${depName}/Entity/${entityType}/AddActionLog`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Status",status)
      .set("Cache-Control", "no-cache");

    return this.http
      .post(baseUrl, actionLogObj, { headers: headers })
      .subscribe({
        next: (data) => {},
        error: (err) => {},
      });
  }

  getActionLogsCount(
    entityType: string,
    entityPath: string,
    entityName: string,
    action: string,
    actionLevel: number,
    initiator: string
  ) {
    if (entityType.charAt(entityType.length - 1).toLowerCase() === "s") {
      entityType = entityType.slice(0, -1); // Remove the last character
    }
    let baseUrl = `${this.env.envVariables.httpProtocol}${this.env.envVariables.webHost}ActionLogs/EntityType/${entityType}/EntityPath/${entityPath}/EntityName/${entityName}/GetActionLogsCount`;
    let headers = new HttpHeaders();
    headers = headers
      .set("Content-Type", "application/json; charset=utf-8")
      .set("Cache-Control", "no-cache")
      .set("ActionToFilter", action)
      .set("ActionLevelToFilter", actionLevel.toString())
      .set("InitiatorToFilter", initiator);
    return this.http.get(baseUrl, { headers: headers });
  }
}
